import React from 'react'
import { createRoot } from 'react-dom/client';
import AppFull from './App'

import { initI18N } from '../../i18next';

const container : HTMLDivElement = document.querySelector("div[id^='purchase-app'")!;
const appType = container.id.includes('full') ? 'full' : 'compact';
const isLegacy = container.dataset.legacy != null;

initI18N().then(() => {
    const root = createRoot(container);
    root.render(<AppFull appType={appType} isLegacy={isLegacy} />);
});
